import { Button, Card, Heading, Text } from "@/design-system";
import { openWhatsApp } from "@/pages/landingPage/utils/whatsapp";

export const MissingIntegrationBand = () => (
  // `id` = destino do item "Outros ERPs" do menu do header.
  <section
    id="outros-erps"
    aria-labelledby="sem-integracao-title"
    className="mx-auto w-full max-w-6xl scroll-mt-28 px-4 sm:px-6 lg:px-8"
  >
    <Card className="bg-ds-surface-sunken flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
      <div className="flex max-w-2xl flex-col gap-2">
        <Heading level={2} size={3} id="sem-integracao-title">
          Seu sistema não está na lista?
        </Heading>
        <Text tone="subtle">
          Integrações com outros ERPs estão em andamento. Enquanto isso, a
          carteira entra por planilha e a cobrança já começa.
        </Text>
      </div>
      <Button
        variant="secondary"
        navigates="external"
        className="shrink-0"
        onClick={() => openWhatsApp("cta_band")}
      >
        Falar com o time no WhatsApp
      </Button>
    </Card>
  </section>
);
